/**
 * Where an integration document came from: the Dynamics 365 PCF ("D365" / "Dynamics") or FillSign's own internal
 * Ops app ("Ops", the contracts FillSign sends to its customers). Drives the small badge on documents.
 */
export const isOpsSource = (source?: string | null) => (source || "").toLowerCase() === "ops";

/** Short badge text. */
export const crmBadge = (source?: string | null) => (isOpsSource(source) ? "Ops" : "D365");

/** Full name, for detail views. */
export const crmName = (source?: string | null) => (isOpsSource(source) ? "FillSign Ops" : "Dynamics 365");
